module.exports = __webpack_public_path__ + "static/media/chair.4ee1208c.png";